import { State } from '~models/consultation'

const APP_QUERY_KEYS_ROOT = ['app'] as const
export const APP_QUERY_KEYS = {
  all: APP_QUERY_KEYS_ROOT,
  myProfile: [...APP_QUERY_KEYS_ROOT, 'myProfile'],
  myPets: [...APP_QUERY_KEYS_ROOT, 'myPets'],
  petKinds: [...APP_QUERY_KEYS_ROOT, 'petKinds'],
  // 펫의 최신 몸무게 (문진 v2 몸무게 질문 미리 채우기)
  petLatestWeight: (petId: string | number) => [
    ...APP_QUERY_KEYS_ROOT,
    'petLatestWeight',
    `${petId}`,
  ],
  /**
   * sort 작업이 없다면 query keys 의 고유성이 보장되지 않음.
   */
  myConsultations: (states: State[]) => [
    ...APP_QUERY_KEYS_ROOT,
    'myConsultations',
    ...states.sort((a, b) => (a > b ? 1 : a === b ? 0 : -1)),
  ],
  relatedConsultations: (id: string | number) => [
    ...APP_QUERY_KEYS_ROOT,
    'relatedConsultations',
    `${id}`,
  ],
} as const

const MODEL_QUERY_KEYS_ROOT = ['model'] as const
export const MODEL_QUERY_KEYS = {
  owner: [...MODEL_QUERY_KEYS_ROOT, 'owner'],
  consultation: {
    all: () => [...MODEL_QUERY_KEYS_ROOT, 'consultation'],
    level1: (id: string | number) => [...MODEL_QUERY_KEYS.consultation.all(), id, 'level1'],
    level2: (id: string | number) => [...MODEL_QUERY_KEYS.consultation.all(), id, 'level2'],
  },
} as const
